import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {UserService} from '../../data-access-layer/services/users.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-dialog',
  standalone: false,
  templateUrl: '../templates/add_user.component.html',
  styleUrl: '../templates/styles/add_user.component.css'
})
export class UserDialogComponent {
  isUserAD: boolean = false;
  public nameAD: string = '';
  user = {name: '', password: ''};

  constructor(private userService: UserService, private dialog: MatDialog, private router: Router) {
  }

  onSave() {
    const getUserRequest = {
      name: this.user.name,
      password: this.user.password,
      role: 'Пользователь'
    };
    this.userService.addUser(getUserRequest).subscribe(() => {
      this.dialog.closeAll();
     
    });

  }

  onSaveAD() {
    this.userService.addUserAD({Name: this.nameAD}).subscribe();
    this.dialog.closeAll();
    this.router.navigate(['/administration']);
  }

  onClose() {
    this.dialog.closeAll();
  }
}
